import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Outlet, Navigate, useParams, ScrollRestoration, useLoaderData, useLocation } from 'react-router-dom';
import { Message, ScrollTop } from './components/PrimereactComponents';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import MunicipalityFooter from './components/MunicipalityFooter';
import MobileBottomNav from './components/MobileBottomNav/MobileBottomNav';
import useDimensions from './hooks/useDimensions';

export const AppLoader = async ({ params }) => {
    const responses = await Promise.all([
        axios.get(`${params.municipalitaId}/${params.bodyType}/${params.zastupitelstvoId}/generalData`),
        axios.get(`municipality/${params.municipalitaId}`),
        axios.get(`${params.municipalitaId}/${params.bodyType}/councils`),
        axios.get('appInfo')
    ]);
    return responses;
};

const ScrollToTop = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
        document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
};

function App() {
    const [mobileBottomNavIsVisible, setMobileBottomNavIsVisible] = useState(true);
    const { t } = useTranslation();
    const { width } = useDimensions();

    const { ready } = useTranslation();

    const response = useLoaderData();
    const basicData = response[0].data;
    const municipality = response[1].data;
    const councils = response[2].data;
    const appInfo = response[3].data;

    var root = document.querySelector(':root');

    if (municipality.barva !== null) {
        //root.style.setProperty('--color-primary', municipality.barva);
    }

    useEffect(() => {
        let lastScrollY = window.scrollY;
        const threshold = 250;

        const handleScroll = () => {
            if (window.scrollY < threshold) {
                setMobileBottomNavIsVisible(true);
                lastScrollY = window.scrollY;
                return;
            }
            if (window.scrollY > lastScrollY) {
                setMobileBottomNavIsVisible(false);
            } else {
                setMobileBottomNavIsVisible(true);
            }
            lastScrollY = window.scrollY;
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    if (basicData !== undefined && ready) {
        if (JSON.stringify(basicData) !== '{"error":"neexistujici ID"}') {
            return (
                <>
                    <div>
                        {basicData.nejnovejsi_zasedani.cislo === undefined && (
                            <Message severity='warn' text={t('limited-dataset-warning')} />
                        )}
                        <div id='body' className='municipality-detail-view'>
                            <ScrollToTop />
                            <ScrollRestoration />
                            <Outlet />
                        </div>
                        <MunicipalityFooter
                            latest_meeting_number={basicData.nejnovejsi_zasedani.cislo}
                            latest_meeting_date={basicData['nejnovejsi_zasedani']['datum']}
                        ></MunicipalityFooter>
                    </div>
                    <ScrollTop
                        style={
                            width < 768
                                ? {
                                      transform: mobileBottomNavIsVisible ? 'translateY(0)' : 'translateY(100%)',
                                      transition: 'transform 0.3s ease'
                                  }
                                : {}
                        }
                    />
                    <MobileBottomNav isVisible={mobileBottomNavIsVisible} />
                </>
            );
        } else {
            return <Navigate to='/' />;
        }
    }
}

export default App;
